/* eslint-disable @typescript-eslint/naming-convention */
export enum AnalyticsFormKey {
  from = 'from',
  to = 'to',
  value = 'value',
  value1 = 'value1',
  unit = 'unit',
  date = 'date',
  minutes = 'minutes'
}

export interface AnalyticsFormKeyInterface {
  id: string,
  index: number,
  value?: number
}
